import React from 'react';
import { X, Phone, Mail, MapPin } from 'lucide-react';
import '../styles/contact-modal.css';

const ContactModal = ({ isOpen, onClose, productName }) => {
  if (!isOpen) return null;

  const handleEmailClick = () => {
    const subject = encodeURIComponent(productName ? `Inquiry about ${productName}` : 'Product Inquiry');
    window.location.href = `mailto:info@sitcorp.ae?subject=${subject}`;
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:+15551234567';
  };

  return (
    <div className="contact-modal-overlay" onClick={onClose}>
      <div className="contact-modal contact-modal-simple" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <X size={24} />
        </button>

        <div className="modal-header">
          <h2>Get in Touch</h2>
          {productName && <p>Interested in {productName}? Contact us below</p>}
          {!productName && <p>We'd love to hear from you</p>}
        </div>

        <div className="modal-contact-info-large">
          <div className="contact-info-card" onClick={handlePhoneClick}>
            <div className="contact-icon-large">
              <Phone size={32} />
            </div>
            <h3>Call Us</h3>
            <p>+971586155995</p>
            <span className="contact-hint">Click to call</span>
          </div>

          <div className="contact-info-card" onClick={handleEmailClick}>
            <div className="contact-icon-large">
              <Mail size={32} />
            </div>
            <h3>Email Us</h3>
            <p>info@sitcorp.ae</p>
            <span className="contact-hint">Click to email</span>
          </div>

          <div className="contact-info-card">
            <div className="contact-icon-large">
              <MapPin size={32} />
            </div>
            <h3>Visit Us</h3>
            <p>Dubai, UAE</p>
          </div>
        </div>

        <div className="modal-footer">
          <p>Our team is ready to assist you with any inquiries</p>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
